<template>
	<span>
		<router-link
			:to="to"
			@mouseenter.native="mouseenter"
			@mouseleave.native="mouseleave"
			>{{ text }}</router-link
		>
	</span>
</template>

<script>
export default {
	name: "MenuItem",
	props: {
		to: String,
		text: String
	},
	methods: {
		mouseenter() {
			this.$root.onHoverTo(this.to);
		},
		mouseleave() {
			this.$root.offHoverTo(this.to);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/MenuLink.vue